module.exports = __webpack_public_path__ + "static/media/telegramBlack.d28cb5eb.png";